import type { ReactNode } from 'react';
import { useOverlay } from '@/lib/overlay';
import { Icon } from './Icon';

const GROUPS: ReadonlyArray<{ title: string; rows: ReadonlyArray<[string, string]> }> = [
    {
        title: 'Everywhere',
        rows: [
            ['⌘K', 'Find a variable, a section, a command'],
            ['E', 'Next environment, same section'],
            ['G V', 'Variables'],
            ['G C', 'Compare'],
            ['G A', 'Activity'],
            ['?', 'These shortcuts'],
        ],
    },
    {
        title: 'In a section',
        rows: [
            ['/', 'Filter the keys'],
            ['N', 'New variable'],
            ['I', 'Import a .env'],
            ['[ ]', 'Previous, next section'],
            ['⇧R', 'Reveal or hide every value'],
        ],
    },
    {
        title: 'On a variable',
        rows: [
            ['↑ ↓', 'Move'],
            ['Space', 'Reveal or hide its value'],
            ['C', 'Copy its value'],
            ['↵', 'Edit it'],
            ['H', 'Its history'],
            ['⌘↵', 'Save, while editing'],
        ],
    },
];

export function Shortcuts(props: { onClose: () => void }): ReactNode {
    useOverlay();
    return (
        <div className="scrim" onMouseDown={(event) => event.target === event.currentTarget && props.onClose()}>
            <div className="shortcuts float">
                <div className="sheet-head">
                    <div>
                        <h2>Keyboard shortcuts</h2>
                        <p>Everything here works without the mouse.</p>
                    </div>
                    <button className="closebtn" onClick={props.onClose} title="Close (esc)">
                        <Icon name="x" size={17} />
                    </button>
                </div>
                <div className="sc-body">
                    {GROUPS.map((group) => (
                        <div key={group.title} className="sc-group">
                            <h3>{group.title}</h3>
                            {group.rows.map(([key, label]) => (
                                <div key={key} className="sc-row">
                                    <span className="kbd">{key}</span>
                                    <span>{label}</span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
